import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { PerformanceCategoryHeadingApiModel } from '@app/api/api-models';
import { HttpClientService } from './http-client.service';

@Injectable()
export class PerformanceCategoriesHeadingService {
  public apiUrl = 'performance-category-headings';

  constructor(private readonly http: HttpClientService) {}

  public update(model: PerformanceCategoryHeadingApiModel): Observable<PerformanceCategoryHeadingApiModel> {
    return this.http.put<PerformanceCategoryHeadingApiModel>(`${this.apiUrl}/update`, model);
  }

  public add(model: PerformanceCategoryHeadingApiModel): Observable<PerformanceCategoryHeadingApiModel> {
    return this.http.post<PerformanceCategoryHeadingApiModel>(`${this.apiUrl}/add`, model);
  }

  public delete(id: number): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/delete/${id}`);
  }
}
